import Phaser from "phaser";
import type { EventCommand } from "../../../../shared/types/GameCommand";

export class EventSystem {
  private activeEvent?: EventCommand & { endsAt: number };
  private readonly banner: Phaser.GameObjects.Text;
  private readonly bannerBack: Phaser.GameObjects.Image;
  private readonly bannerIcon: Phaser.GameObjects.Image;
  private readonly overlay: Phaser.GameObjects.Rectangle;

  constructor(private readonly scene: Phaser.Scene) {
    this.overlay = scene.add.rectangle(640, 360, 1280, 720, 0x24334a, 0).setDepth(65).setScrollFactor(0);
    this.bannerBack = scene.add.image(640, 72, "lane_panel").setDepth(119).setScrollFactor(0).setAlpha(0);
    this.bannerBack.setDisplaySize(204, 44);
    this.bannerIcon = scene.add.image(562, 72, "spawn_warning").setDepth(120).setScrollFactor(0).setAlpha(0);
    this.bannerIcon.setDisplaySize(28, 28);
    this.banner = scene.add
      .text(652, 72, "", {
        fontFamily: "\"Apple SD Gothic Neo\", \"Noto Sans KR\", \"Malgun Gothic\", sans-serif",
        fontSize: "16px",
        color: "#f8efc9",
        stroke: "#111016",
        strokeThickness: 4
      })
      .setOrigin(0.5)
      .setDepth(120)
      .setScrollFactor(0);
  }

  apply(command?: EventCommand) {
    if (!command || command.type === "none") return;
    this.activeEvent = {
      ...command,
      endsAt: this.scene.time.now + command.durationSec * 1000
    };
    this.banner.setText(command.type.replaceAll("_", " ").toUpperCase());
    this.bannerBack.setAlpha(0.92);
    this.bannerIcon.setAlpha(0.95);
    this.scene.tweens.add({
      targets: [this.bannerBack, this.bannerIcon, this.banner],
      y: { from: 66, to: 72 },
      duration: 180,
      ease: "Sine.easeOut"
    });
    this.overlay.setAlpha(command.type.includes("fog") ? 0.22 : command.type === "rain" ? 0.16 : 0.08);
  }

  update(time: number) {
    if (this.activeEvent && time >= this.activeEvent.endsAt) {
      this.activeEvent = undefined;
      this.banner.setText("");
      this.bannerBack.setAlpha(0);
      this.bannerIcon.setAlpha(0);
      this.overlay.setAlpha(0);
    }
  }

  get rangeMultiplier() {
    if (!this.activeEvent) return 1;
    return this.activeEvent.type.includes("fog") ? 0.82 : 1;
  }

  get powderMultiplier() {
    if (!this.activeEvent) return 1;
    return this.activeEvent.type === "rain" ? 0.75 : 1;
  }
}
